import { render, staticRenderFns } from "./Desembolsos.vue?vue&type=template&id=2736afce&scoped=true"
import script from "./Desembolsos.vue?vue&type=script&lang=js"
export * from "./Desembolsos.vue?vue&type=script&lang=js"
import style0 from "./Desembolsos.vue?vue&type=style&index=0&id=2736afce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2736afce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VFileInput,VIcon})
